import config from '../../config'
import axios from 'axios'

class API {  
  static tasks() {
    const url = `${config.api.baseurl}${config.api.apiurl}${config.api.methods.tasks}`

    return axios
      .get(url)
      .then(response => {
        return response.data
      }).catch(() => {
        return 'error'
      })
  } 

  static process(id, expression) {
    const url = `${config.api.baseurl}${config.api.apiurl}${config.api.methods.process}`
    const data = {
      tasks: [
        {
          id: id,
          expression: expression
        }
      ]
    }

    return axios
      .post(url, data)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return 'error'
      })
  }

  static results(tasks, user) {
    const url = `${config.api.baseurl}${config.api.apiurl}${config.api.methods.results}`
    const data = {
      tasks: tasks,
      user: user
    }

    return axios
      .post(url, data)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return 'error'
      })
  }
}

export default API
